import React from "react"
import classnames from "classnames"
import styles from "./Offers.less"
import { WINDOW } from "AtomicUtils/environment"
import componentParser from "AtomicUtils/componentParser"
import gtmHandler from "AtomicUtils/gtmHandler"
import urlHandler from "AtomicUtils/urlHandler"
import { scrollToElementId } from "AtomicUtils/scroll"
import { IdWrapper, StickySection, InputSelect, P, A, Caption, Button, Modal, Space } from "AtomicComponents"
import { Image, OffersFilters } from "AtomicContainers"

class Offers extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filters: {
        nameplate: [],
        price: {},
        transmission: [],
        drivetrain: []
      },
      sort: props.sortOptions && props.sortOptions.options && props.sortOptions.options[0].value,
      mobileFiltersOpen: false
    }
  }

  componentDidMount() {
    const hash = new urlHandler(WINDOW.location.href).getHash()

    if (hash) {
      setTimeout(() => {
        scrollToElementId(hash)
      }, 1000)
    }
  }

  handleChange = (filters) => {
    if (
      (filters.nameplate && filters.nameplate.length !== this.state.filters.nameplate.length) ||
      (filters.price && filters.price.min && (filters.price.min !== this.state.filters.price.min || filters.price.max !== this.state.filters.price.max)) ||
      (filters.transmission && filters.transmission.length !== this.state.filters.transmission.length) ||
      (filters.drivetrain && filters.drivetrain.length !== this.state.filters.drivetrain.length)
    ) {
      this.setState({
        filters
      }, () => {
        let gtmAction = ""
        if (filters.nameplate.length) {
          filters.nameplate.map((nameplate, i) => {
            i=== 0 ? (gtmAction += nameplate) : (gtmAction += ` and ${nameplate}`)
          })
          gtmAction += " / "
        }
        gtmAction += filters.price.min + " to " + filters.price.max
        if (filters.transmission.length) {
          gtmAction += " / "
          filters.transmission.map((transmission, i) => {
            i === 0 ? (gtmAction += transmission) : (gtmAction += ` and ${transmission}`)
          })
        }
        if (filters.drivetrain.length) {
          gtmAction += " / "
          filters.drivetrain.map((drivetrain, i) => {
            i === 0 ? (gtmAction += drivetrain) : (gtmAction += ` and ${drivetrain}`)
          })
        }

        gtmHandler({
          pageCategory: "Offers",
          pageAction: `Filtering - "${gtmAction}"`
        })
      })
    }
  }

  handleSortChange = (value) => {
    this.setState({
      sort: value
    })
  }

  handleOnClose = () => {
    this.setState({
      mobileFiltersOpen: false
    })
  }

  handleOnShow = () => {
    this.setState({
      mobileFiltersOpen: true
    })
  }

  render() {
    const { offers, imageSrc, description, sortOptions, termsAndConditions, promoComponent } = this.props
    const { filters, mobileFiltersOpen, sort } = this.state
    const noOfOffers = filters.nameplate.length + filters.transmission.length + filters.drivetrain.length
    const SORT = sortOptions && sortOptions.options && sortOptions.options
      .map(({ name, value }) => ({
        label: name,
        value
      }))

    const filteredOffers = offers
    .filter(c => {
      return (
        (filters.nameplate.indexOf(c.props.nameplateFilter) !== -1 || filters.nameplate.length === 0) &&
        (c.props.priceFilter >= filters.price.min && c.props.priceFilter <= filters.price.max) &&
        (filters.transmission.indexOf(c.props.transmissionFilter) !== -1 || c.props.transmissionFilter === "all" || filters.transmission.length === 0) &&
        (filters.drivetrain.length === 0 || c.props.drivetrainFilter.some(r => (filters.drivetrain.indexOf(r) !== -1)))
      )
    })
    .sort((a, b) => {
      return sort === "price--low-to-high-" ? (a.props.priceFilter - b.props.priceFilter) : (sort === "price--high-to-low-" ? (b.props.priceFilter - a.props.priceFilter) : 0)
    })

    return (
      <div
        className={classnames({
          [styles.Offers]: true
        })}>
        <OffersFilters {...this.props} onChange={this.handleChange} open={mobileFiltersOpen} onClose={this.handleOnClose} />
        <div
          className={classnames({
            [styles.OffersContent]: true
          })}>
            <div
              className={classnames({
                [styles.OffersFiltersTrigger]: true
              })}>
              <Button
                styleName="black"
                fullWidth
                onClick={this.handleOnShow}
              >
                Refine Search
              </Button>
            </div>
            <div
              className={classnames({
                [styles.OffersListInfo]: true
              })}>
              <Caption>
                <span>Filters applied (<b>{noOfOffers}</b>)</span>
                <span
                  className={classnames({
                    [styles.OffersListInfoHideMobile]: true
                  })}>Vehicles available (<b>{filteredOffers.length}</b>)</span>
              </Caption>
              {
                sortOptions && sortOptions.options &&
                <div>
                  <InputSelect
                    name="sort"
                    label="Sort by"
                    formType="compact"
                    options={SORT}
                    onChange={this.handleSortChange}
                    required
                    withoutStar
                    defaultValue={SORT[0]}
                  />
                </div>
              }
            </div>
            <Space />
            {/* Hiding it for now as per SM-5696 */}
            {/* <div
              className={classnames({
                [styles.OffersListHeader]: true
              })}>
              <div
                className={classnames({
                  [styles.OffersListHeaderImage]: true
                })}>
              {imageSrc && <img src={imageSrc} />}
              </div>
              <P>{description} <A styleName="black" href={termsAndConditions}>Ts & Cs apply. </A></P>
            </div> */}
            <div
              className={classnames({
                [styles.OffersList]: true
              })}>
              {filteredOffers.length ? filteredOffers.map((offer, index) => (
                <IdWrapper key={index} slug={offer.props.slug} standalone>
                  {componentParser([offer])}
                  {
                    ((index === 0 && filteredOffers.length === 1) || index === 1 ) &&
                    promoComponent &&
                    <div style={{
                      borderTop: "1px solid #D5D5D5",
                      borderBottom: (filteredOffers.length === 1 || filteredOffers.length === 2) ? "1px solid #D5D5D5" : 0 }}>
                      {componentParser([promoComponent])}
                    </div>
                  }
                </IdWrapper>
              )) :
              <div
                className={classnames({
                  [styles.OffersListZero]: true
                })}>
                <P>Your search returned no results. Search again.</P>
              </div>
              }
            </div>
        </div>
      </div>
    )
  }
}

export default Offers



// WEBPACK FOOTER //
// ./src/AtomicContainers/Offers/Offers.jsx